import PriceConfigurator from "@/components/configurator/PriceConfigurator";

const Configurator = () => {
  return (
    <>
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="mx-auto mb-12 max-w-2xl text-center">
            <h1 className="text-3xl font-bold md:text-4xl">
              Bereken je <span className="text-gradient">maandprijs</span>
            </h1>
            <p className="mt-4 text-lg text-muted-foreground">
              Selecteer de diensten die je nodig hebt en zie direct wat het kost. Transparant, eerlijk en zonder verplichtingen.
            </p>
          </div>
          <PriceConfigurator />
        </div>
      </section>
    </>
  );
};

export default Configurator;
